function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Dialog, SurveyForm } from "./..";
import React from 'react';
import "./index.less";
var SurveyFormModal = function SurveyFormModal(props) {
  var surveyFormProps = props.surveyFormProps,
    dialogProps = props.dialogProps;
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, dialogProps, {
    classNames: {
      all: 'iron-survey-dialog'
    }
  }), dialogProps.isOpen && /*#__PURE__*/React.createElement(SurveyForm, surveyFormProps));
};
export default SurveyFormModal;